import { render, staticRenderFns } from "./TariffVWindow.vue?vue&type=template&id=2804802e"
import script from "./TariffVWindow.vue?vue&type=script&lang=js"
export * from "./TariffVWindow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports